<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div class="dictionaryList">
    <!--筛选条-->
    <el-form class="z-plate__operation-bar" inline @submit.native.prevent>
      <div style="text-align: right;padding: 0 10px;padding-bottom: 10px;margin-top: 10px;float: right;text-align: left;">
        <el-button type="primary" size="small" @click="handleAdd()" id="dictAddGroup">新增通知</el-button>
        <el-upload
            style="margin: 0 15px;display: inline-block"
            :disabled="loadingFalse"
            :show-file-list="false"
            name="uploadFile"
            ref="upload"
            :limit="1"
            :before-upload="beforeAvatarUpload"
            :data="uploadData"
            :on-success="handleSuccess"
            class="upload-demo"
            action="api/admin/SysTzController/tzListImport">
          <el-button type="primary" size="small" :disabled="loadingFalse">批量导入通知</el-button>
        </el-upload>
        <el-button type="primary" size="small" @click="downloadTemplate()">下载导入模板</el-button>
      </div>
    </el-form>
    <section class="z-plate__container">
      <div slot="content" class="tz-table-content">
        <el-table :data="tableDatas" border style="width: 100%" v-loading="loading">
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column prop="bt" label="标题" show-overflow-tooltip></el-table-column>
          <el-table-column label="内容" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-html="scope.row.nr"></span>
            </template>
          </el-table-column>
          <el-table-column label="学校" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-for="(item,index) in scope.row.xxMcs">
                {{item}}
                <span v-if="index != scope.row.xxMcs.length-1">、</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="zt" label="状态" width="80px">
            <template slot-scope="scope">
              <span v-if="scope.row.zt == 0">未发布</span>
              <span v-if="scope.row.zt == 1">已发布</span>
            </template>
          </el-table-column>
          <el-table-column prop="gxsj" label="发布时间">
            <template slot-scope="scope">
              <span v-if="scope.row.gxsj == '' || scope.row.gxsj == null"></span>
              <span v-if="scope.row.zt == 1 && scope.row.gxsj != '' && scope.row.gxsj != null">{{formatDate(new Date(scope.row.gxsj),'yyyy.MM.dd hh:mm')}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="cjrmc" label="创建人"></el-table-column>
          <el-table-column prop="gxsj" label="更新时间">
            <template slot-scope="scope">
              <span v-if="scope.row.gxsj == '' || scope.row.gxsj == null"></span>
              <span v-if="scope.row.gxsj != '' && scope.row.gxsj != null">{{formatDate(new Date(scope.row.gxsj),'yyyy.MM.dd hh:mm')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="230px">
            <template slot-scope="scope">
              <el-button v-if="scope.row.zt == 0" @click="handleEdit(scope.$index, scope.row)" type="primary" size="mini">编辑</el-button>
              <el-button v-if="scope.row.zt == 0" @click="handleStatus(scope.row.id,1)" type="primary" size="mini">发布</el-button>
              <el-button v-if="scope.row.zt == 1" @click="handleStatus(scope.row.id,0)" type="primary" size="mini">取消发布</el-button>
              <el-button v-if="scope.row.zt == 0" @click="handleDel(scope.row.id)" type="danger" size="mini">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </section>

    <!--编辑-->
    <el-dialog title="修改信息" :visible.sync="dialogFormVisible" @close="refresh" :close-on-click-modal="false">
      <el-form :model="selectTable" :rules="rules" ref="selectTable" label-width="100px" class="demo-ruleForm tzadd-form">
        <el-form-item label="标题" prop="bt">
          <el-input v-model="selectTable.bt" auto-complete="off" id="editBt"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="nr">
          <quill-editor ref="text" v-model="selectTable.nr" :options="editorOption" class="ql-editor myQuillEditor"/>
        </el-form-item>
        <el-form-item label="学校" prop="xxIds">
          <el-select v-model="selectTable.xxIds" multiple placeholder="请选择学校" style="width:100%">
            <el-option v-for="item in xxList" :key="item.id" :label="item.xxmc" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-upload
              name="uploadFile"
              action="api/sys/uploadSysAttachment"
              :data="{ 'access_token': accessToken, 'attachmentType': 'tzgg' }"
              :before-remove="beforeRemove"
              :on-success="handleUploadSuccess"
              multiple
              :file-list="fileList"
              accept=".doc,.docx,.pdf,.txt,.xls,.xlsx,.ppt,.pptx">
            <el-button type="text">上传附件</el-button>
            <div slot="file" slot-scope="{file}">
              <span @click="showFile(file.previewUrl)" style="color: #409EFF;cursor: pointer;">{{file.realName}}</span>
              <span class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-delete" style="display: inline-block" @click="handleRemove(file)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button id="dictEditCancel" @click="dialogFormVisible = false">取 消</el-button>
        <el-button id="dictEditSubmit" type="primary" @click="submitForm('selectTable','update')">确 定</el-button>
      </div>
    </el-dialog>

    <!--添加-->
    <el-dialog title="添加" :visible.sync="dialogAddFormVisible" @close="resetForm('ruleForm')" :close-on-click-modal="false">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm tzadd-form">
        <el-form-item label="标题" prop="bt">
          <el-input v-model="ruleForm.bt" id="addBt"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="nr">
          <quill-editor ref="text" v-model="ruleForm.nr" :options="editorOption" class="ql-editor myQuillEditor"/>
        </el-form-item>
        <el-form-item label="学校" prop="xxIds">
          <el-select v-model="ruleForm.xxIds" multiple placeholder="请选择学校" style="width:100%">
            <el-option v-for="item in xxList" :key="item.id" :label="item.xxmc" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-upload
              name="uploadFile"
              action="api/sys/uploadSysAttachment"
              :data="{ 'access_token': accessToken, 'attachmentType': 'tzgg' }"
              :before-remove="beforeRemove"
              :on-success="handleUploadSuccess"
              multiple
              :file-list="fileList"
              accept=".doc,.docx,.pdf,.txt,.xls,.xlsx,.ppt,.pptx">
            <el-button type="text">上传附件</el-button>
            <div slot="file" slot-scope="{file}">
              <span @click="showFile(file.previewUrl)" style="color: #409EFF;cursor: pointer;">{{file.realName}}</span>
              <span class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-delete" style="display: inline-block" @click="handleRemove(file)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button id="dictAddSumbit" type="primary" @click="submitForm('ruleForm','add')">立刻添加</el-button>
          <el-button id="dictAddReset" @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { quillEditor } from "vue-quill-editor";
export default {
  name: 'dictionaryList',
  data: function () {
    var validateSort = (rule, value, callback) => {
      var str=/^\d+$/g;
      var flag = str.test(value);
      if (flag) {
        callback();
      } else {
        callback(new Error('输入值必须为大于等于0的正整数'));
      }
    };
    return {
      tableDatas: [],
      selectTable: {},
      dialogFormVisible: false,
      dialogTableVisible: false,
      dialogAddFormVisible: false,
      dictIDatas: [],
      loading: true,
      loadingFalse: false,
      uploadData: {
        access_token: sessionStorage.getItem('access_token'),
      },
      xxList: [],
      ruleForm: {
        bt: '',
        nr: '',
        xxIds: [],
        attachmentIds: [],
      },
      rules: {
        bt: [
          {required: true, message: '请输入标题', trigger: 'blur'},
          {max: 200, message: '长度不超过200个字符', trigger: 'blur'}
        ],
        nr: [
          {required: true, message: '请输入内容', trigger: 'blur'}
        ],
        xxIds: [
          {required: true, message: '请选择学校', trigger: 'blur'}
        ],
      },
      editorOption:{
        placeholder: '请输入段落文字',
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'], // toggled buttons
              ['blockquote', 'code-block'],
              [{ header: 1 }, { header: 2 }], // custom button values
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
              [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
              [{ direction: 'rtl' }], // text direction
              [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ color: [] }, { background: [] }], // dropdown with defaults from theme
              [{ font: [] }],
              [{ align: [] }]
            ]},
        }
      },
      accessToken: sessionStorage.getItem('access_token'),
      fileList: [],
    }
  },
  components:{quillEditor},
  props: {},
  created() {
  },
  mounted() {
    this.findXuexiaoList();
    this.queryTzList();
  },
  methods: {
    findXuexiaoList(){
      var _this = this;
      var params = {
        xxmc: _this.xxmc
      }
      _this.$post("user/JichuXuexiaoController/findXuexiaoList",params).then(rep =>{
        _this.xxList = rep.result.xxList;
      })
    },
    //通知列表
    queryTzList() {
      var _this = this;
      _this.$post('admin/SysTzController/sysTzList').then(function(response){
        if (response.code == '1'){
          _this.loading = false;
          _this.tableDatas = response.result.tzList;
        }
      }).catch(function (error) {
//      console.log(error);
      })
    },
    //增加弹窗
    handleAdd() {
      this.dialogAddFormVisible = true;
    },
    //编辑窗口
    handleEdit(index, row) {
      console.log(row)
      this.selectTable = row;
      this.dialogFormVisible = true;
    },
    //验证表单
    submitForm(formName,type) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveTz(type);
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.refresh();
    },
    //请求后台增加
    saveTz(type) {
      var _this = this;
      var params = {};

      if (_this.fileList){
        _this.fileList.forEach(item => {
          _this.ruleForm.attachmentIds.push(item.attachmentId);
        })
      }
      if(type === 'update'){
        params = {
          id: _this.selectTable.id,
          bt: _this.selectTable.bt,
          nr: _this.selectTable.nr,
          xxIds: _this.selectTable.xxIds,
          attachmentIds: _this.ruleForm.attachmentIds
        }
      }else if(type === 'add'){
        params = {
          bt: _this.ruleForm.bt,
          nr: _this.ruleForm.nr,
          xxIds: _this.ruleForm.xxIds,
          attachmentIds: _this.ruleForm.attachmentIds
        }
      }
      _this.$post('admin/SysTzController/sysTzSave', params,'json').then(function (response) {
        if (response.code == '1') {
          if(type === 'add'){
            _this.dialogAddFormVisible = false;
          }else if(type === 'update'){
            _this.dialogFormVisible = false;
          }
          _this.$message({
            type: 'success',
            message:  '保存通知成功'
          });
          _this.queryTzList();
        }else{
          _this.$message({
            type: 'error',
            message: response.msg
          });
        }
      }).catch(function (error) {
//        console.log(error);
      })
    },
    //发布
    handleStatus(id,type) {
      var typeName;
      if(type == 1) {
        typeName="发布";
      }else {
        typeName="取消发布";
      }
      this.$confirm('是否确认'+typeName+'?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var _this = this;
        _this.$post('admin/SysTzController/sysTzStatusSave',{
          id: id,
          status:type
        }).then(function(response){
          if (response.code == '1') {
            _this.$message({
              type: 'success',
              message:  typeName+'成功'
            });
            _this.$emit('getNewtz');
            _this.queryTzList();
          }else{
            _this.$message({
              type: 'error',
              message: response.msg
            });
          }
        }).catch(function (error) {
//        console.log(error);
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    //删除
    handleDel(id) {
      this.$confirm('是否删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var _this = this;
        _this.$post('admin/SysTzController/sysTzDel',{
          id: id
        }).then(function(response){
          if (response.code == '1') {
            var flag = response.result.deleteCode;
            _this.$message({
              type: 'success',
              message:  '删除成功'
            });
            _this.queryTzList();
          }else{
            _this.$message({
              type: 'error',
              message: response.msg
            });
          }
        }).catch(function (error) {
//        console.log(error);
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //下载模板
    downloadTemplate() {
      const token = sessionStorage.getItem('access_token');
      //window.location.href = `http://127.0.0.1:9700/ftxmgl/api/admin/SysTzController/getTongzhiTemplate?access_token=${token}`;
      window.location.href = `api/admin/SysTzController/getTongzhiTemplate?access_token=${token}`;
    },
    beforeAvatarUpload() {
      this.loadingFalse = true;
    },
    handleSuccess(res) {
      this.loadingFalse = false;
      if (res.code === '1') {
        this.$message({
          message: '导入成功',
          type: 'success'
        })
        this.queryTzList();
      } else {
        this.$message({
          message: `${res.data.msg}`,
          type: 'error'
        })
      }
      this.$refs.upload.clearFiles(); //上传成功之后清除历史记录
    },
    //编辑框关闭跳转
    refresh(){
      this.queryTzList();
    },
    // 上传文件成功时
    handleUploadSuccess(response) {
      if (response.code == '1') {
        var attachment = response.result.sysAttachment;
        //this.ruleForm.attachmentIds.push(attachment.attachmentId);
        this.fileList.push(attachment);
        this.$message({
          type: 'success',
          message: '上传成功!'
        });
      }
    },
    // 上传文件删除时
    handleRemove(file, fileList) {
      var _this = this;
      return _this.$confirm(`确定移除该文件吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const index = _this.fileList.findIndex((item) => {
          return item.uid === file.uid;
        })
        //_this.ruleForm.attachmentIds.splice(index, 1);
        _this.fileList.splice(index, 1);
        _this.$message.success('删除成功');
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消'
        });
      })
    },
    // 上传文件 删除之前时提示
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	.dictionaryList,.z-plate__container{
		height: 100%;
	}
	.tz-table-content{
		height: 100%;
	}
	.tzadd-form{
		.ql-container{
			height: 200px;
		}
		.myQuillEditor{
			padding: 10px 0;
			line-height: 0;
		}
	}
</style>
